import { render, staticRenderFns } from "./PaymentCart.vue?vue&type=template&id=3455ba92&scoped=true"
import script from "./PaymentCart.vue?vue&type=script&lang=js"
export * from "./PaymentCart.vue?vue&type=script&lang=js"
import style0 from "./PaymentCart.vue?vue&type=style&index=0&id=3455ba92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3455ba92",
  null
  
)

export default component.exports